"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgStar = props => (0, jsx_runtime_1.jsx)("svg", {
  "data-name": "Component 51 \\u2013 23",
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  ...props,
  children: (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Path 184",
    d: "M5 0l1.768 3.232L10 5 6.768 6.768 5 10 3.232 6.768 0 5l3.232-1.768z",
    fill: "#fbb863"
  })
});
exports.default = SvgStar;